import useSWR from 'swr';

import { Collateral, CompanyProfile } from 'models';
import { CollateralHelpers } from 'helpers/CollateralHelpers';

import { CollateralService } from 'services/CollateralService';

import { prepareConditionalSwrArgs } from './prepare-conditional-swr-args';

const useCollateral = (
    company: Pick<CompanyProfile, 'id' | 'collateralOrder'> | null | undefined,
    fallbackData?: Collateral[],
) => {
    const swr = useSWR(
        ...prepareConditionalSwrArgs({
            key: CollateralHelpers.swr.list(company?.id ?? ''),
            fetcher: () => CollateralService.list(company!.id),
            condition: Boolean(company),
        }),
        { fallbackData },
    );

    const order = company?.collateralOrder;

    const items = swr.data ?? [];
    const ordered = (order ?? [])
        .map((id) => items.find((item) => item.id === id))
        .filter((item): item is Collateral => !!item);
    const unordered = items.filter((item) => !order?.includes(item.id));

    return {
        ...swr,
        collateral: [...ordered, ...unordered],
    };
};

export { useCollateral };
